import React from 'react';
import { FiX } from 'react-icons/fi';

/**
 * Modal para mostrar contenido legal sin salir de la app (PWA-friendly)
 */
const LegalModal = ({ isOpen, onClose, type }) => {
  if (!isOpen) return null;

  const content = {
    privacy: {
      title: 'Política de Privacidad',
      body: (
        <>
          <p className="text-sm text-gray-500 mb-4">Última actualización: 2 de noviembre de 2025</p>
          <p className="mb-4"><strong>Reserberry</strong> trata los datos personales conforme al RGPD y normativa aplicable. Este documento explica qué datos recogemos, para qué, y tus derechos.</p>
          
          <h3 className="font-semibold text-gray-900 mt-6 mb-2">Responsable</h3>
          <p className="text-gray-700">María de los Ángeles Morales Márquez (DNI 45.747.680-J). Domicilio profesional: Calle Río Retortillo, 14, 29651 Mijas, Málaga (España). Contacto: <a href="mailto:navora.citas@gmail.com" className="text-primary-600 hover:underline">navora.citas@gmail.com</a>.</p>
          
          <h3 className="font-semibold text-gray-900 mt-6 mb-2">Datos que tratamos</h3>
          <ul className="list-disc list-inside text-gray-700 space-y-1">
            <li>Identificación: nombre, email, teléfono (si el usuario los facilita).</li>
            <li>Uso del servicio: reservas, horarios y preferencias.</li>
            <li>Facturación/suscripción: gestionada por Stripe. No almacenamos datos de tarjeta.</li>
          </ul>
          
          <h3 className="font-semibold text-gray-900 mt-6 mb-2">Finalidades</h3>
          <ul className="list-disc list-inside text-gray-700 space-y-1">
            <li>Prestar el servicio de reservas y gestión.</li>
            <li>Comunicaciones relacionadas con la cuenta y recordatorios.</li>
            <li>Mejora del servicio y seguridad.</li>
          </ul>
          
          <h3 className="font-semibold text-gray-900 mt-6 mb-2">Legitimación</h3>
          <p className="text-gray-700">Ejecutar el contrato (art. 6.1.b RGPD) y consentimiento cuando aplique.</p>
          
          <h3 className="font-semibold text-gray-900 mt-6 mb-2">Destinatarios</h3>
          <p className="text-gray-700">Proveedores necesarios (Firebase/Google), Stripe (incluyendo métodos de pago como PayPal), <strong>Brevo</strong> (envío de correos transaccionales) y Google Analytics (solo tras consentimiento), bajo contratos y garantías adecuadas.</p>
          
          <h3 className="font-semibold text-gray-900 mt-6 mb-2">Derechos</h3>
          <p className="text-gray-700">Acceso, rectificación, supresión, oposición, limitación y portabilidad. Solicitudes: <a href="mailto:navora.citas@gmail.com" className="text-primary-600 hover:underline">navora.citas@gmail.com</a>.</p>
          
          <h3 className="font-semibold text-gray-900 mt-6 mb-2">Conservación</h3>
          <p className="text-gray-700">Mientras dure la relación y el tiempo necesario para obligaciones legales.</p>
          
          <h3 className="font-semibold text-gray-900 mt-6 mb-2">Transferencias internacionales</h3>
          <p className="text-gray-700">Algunos proveedores pueden tratar datos fuera del EEE. Se aplican Cláusulas Contractuales Tipo de la UE y medidas adicionales cuando corresponda.</p>
        </>
      )
    },
    terms: {
      title: 'Términos de Servicio',
      body: (
        <>
          <p className="mb-4">Estos Términos regulan el uso de <strong>Reserberry</strong>. Al registrarte o usar la plataforma aceptas estas condiciones.</p>
          
          <h3 className="font-semibold text-gray-900 mt-6 mb-2">Cuenta</h3>
          <p className="text-gray-700">El usuario es responsable de la veracidad de sus datos y de mantener segura su cuenta.</p>
          
          <h3 className="font-semibold text-gray-900 mt-6 mb-2">Uso del servicio</h3>
          <ul className="list-disc list-inside text-gray-700 space-y-1">
            <li>No se permite un uso fraudulento o que vulnere derechos de terceros.</li>
            <li>El servicio puede actualizarse y mejorar con nuevas versiones.</li>
          </ul>
          
          <h3 className="font-semibold text-gray-900 mt-6 mb-2">Suscripciones y pagos</h3>
          <p className="text-gray-700">Los cobros se gestionan mediante Stripe (incluyendo PayPal como método de pago). Las condiciones de precio y periodos de prueba se mostrarán en la contratación.</p>
          
          <h3 className="font-semibold text-gray-900 mt-6 mb-2">Limitación de responsabilidad</h3>
          <p className="text-gray-700">Proporcionamos el servicio "tal cual". No respondemos por caídas de terceros proveedores inevitables.</p>
          
          <h3 className="font-semibold text-gray-900 mt-6 mb-2">Soporte</h3>
          <p className="text-gray-700">Contacto: <a href="mailto:navora.citas@gmail.com" className="text-primary-600 hover:underline">navora.citas@gmail.com</a>.</p>
          
          <p className="text-sm text-gray-500 mt-6">Última actualización: 15 de octubre de 2025</p>
        </>
      )
    },
    legal: {
      title: 'Aviso Legal',
      body: (
        <>
          <p className="text-gray-700 mb-2"><strong>Titular:</strong> María de los Ángeles Morales Márquez (DNI 45.747.680-J)</p>
          <p className="text-gray-700 mb-2"><strong>Domicilio profesional:</strong> Calle Río Retortillo, 14, 29651 Mijas, Málaga (España)</p>
          <p className="text-gray-700 mb-4"><strong>Email de contacto:</strong> <a href="mailto:navora.citas@gmail.com" className="text-primary-600 hover:underline">navora.citas@gmail.com</a></p>
          
          <h3 className="font-semibold text-gray-900 mt-6 mb-2">Condiciones de uso</h3>
          <p className="text-gray-700">El acceso y uso del sitio implica la aceptación del Aviso Legal, Términos y Política de Privacidad.</p>
          
          <h3 className="font-semibold text-gray-900 mt-6 mb-2">Propiedad intelectual</h3>
          <p className="text-gray-700">El contenido, marcas y diseño pertenecen a sus respectivos titulares y se protegen por la ley.</p>
          
          <h3 className="font-semibold text-gray-900 mt-6 mb-2">Responsabilidad de los contenidos</h3>
          <p className="text-gray-700">No nos responsabilizamos por el mal uso del sitio o por contenidos de terceros enlazados.</p>
          
          <p className="text-sm text-gray-500 mt-6">Última actualización: 15 de octubre de 2025</p>
        </>
      )
    }
  };

  const currentContent = content[type] || content.legal;

  return (
    <div 
      className="fixed inset-0 bg-black/50 backdrop-blur-sm flex justify-center items-start z-50 p-4 overflow-y-auto"
      onClick={onClose}
    >
      <div 
        className="bg-white rounded-2xl shadow-2xl w-full max-w-lg my-8 animate-scale-in"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="flex items-center justify-between p-4 border-b border-gray-100">
          <h2 className="text-xl font-bold text-gray-900">{currentContent.title}</h2>
          <button 
            onClick={onClose}
            className="p-2 rounded-full hover:bg-gray-100 transition-colors"
          >
            <FiX className="w-5 h-5 text-gray-500" />
          </button>
        </div>
        
        {/* Body */}
        <div className="p-6 max-h-[70vh] overflow-y-auto">
          {currentContent.body}
        </div>
        
        {/* Footer */}
        <div className="p-4 border-t border-gray-100">
          <button 
            onClick={onClose}
            className="w-full py-2.5 px-4 bg-primary-600 hover:bg-primary-700 text-white font-medium rounded-xl transition-colors"
          >
            Cerrar
          </button>
        </div>
      </div>
    </div>
  );
};

export default LegalModal;




